import { IconShare } from "@/assets/icons/geist/IconShare";
import { Button } from "@/components/flexkit/Button";
import { useResourcePermissions } from "@/hooks/use-resource-permissions";
import { useShareResource } from "@/hooks/use-share-resource";
import { useRunner } from "@/queries/runner-queries";
import { useOrganization } from "@/queries/organization-queries";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { OrganizationTier } from "gitpod-next-api/gitpod/v1/organization_pb";
import { type FC } from "react";

type ShareRunnerButtonProps = {
    runnerId: string;
};

export const ShareRunnerButton: FC<ShareRunnerButtonProps> = ({ runnerId }) => {
    const { openShareDialog } = useShareResource();
    const { data: runner } = useRunner(runnerId);
    const { data: organization } = useOrganization();
    const isEnterpriseTier = organization?.tier === OrganizationTier.ENTERPRISE;
    const { hasPermission } = useResourcePermissions({ enabled: isEnterpriseTier });

    const canGrantRunner = hasPermission(ResourceType.RUNNER, runnerId, "runner:grant");

    const handleShareClick = () => {
        if (runner) {
            openShareDialog({
                resourceType: ResourceType.RUNNER,
                resourceId: runner.runnerId,
                resourceName: runner.name || "Untitled Runner",
            });
        }
    };

    if (!canGrantRunner) {
        return null;
    }

    return (
        <Button
            variant="outline"
            onClick={handleShareClick}
            disabled={!runner}
            data-testid="share-runner-button"
            data-tracking-id="share-runner-button"
            LeadingIcon={IconShare}
            size={"sm"}
        >
            Share
        </Button>
    );
};
